if (module.hot) {
    module.hot.accept();
}
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import axios from "./utils/httpAxios.js";
import Cookie from "js-cookie";
import "lib-flexible";
import "./utils/setWxFontSize";
import CusField from './components/common/Field'

Vue.use(CusField)

import {
    Button,
    Collapse,
    CollapseItem,
    Checkbox,
    CheckboxGroup,
    Icon,
    Field,
    Popup,
    Picker,
    Actionsheet,
    Tab,
    Tabs,
    Cell,
    CellGroup,
    Panel,
    Search,
    PullRefresh,
    List,
    RadioGroup,
    Radio,
    AddressEdit,
    Uploader,
    Area,
    Row,
    Col,
    DatetimePicker,
    Steps,
    Step,
    Rate,
    Dialog,
    NoticeBar,
    ImagePreview,
    Swipe,
    SwipeItem,
    Lazyload
} from "vant";

Vue.config.ignoredElements = ['wx-open-launch-weapp']

Vue.use(VueClipboard)
    .use(Button)
    .use(Collapse)
    .use(CollapseItem)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Icon)
    .use(Field)
    .use(Popup)
    .use(Picker)
    .use(Actionsheet)
    .use(Tab)
    .use(Tabs)
    .use(Cell)
    .use(CellGroup)
    .use(Panel)
    .use(Search)
    .use(PullRefresh)
    .use(List)
    .use(Radio)
    .use(RadioGroup)
    .use(AddressEdit)
    .use(Uploader)
    .use(Area)
    .use(Row)
    .use(Col)
    .use(DatetimePicker)
    .use(Step)
    .use(Steps)
    .use(Rate)
    .use(Dialog)
    .use(NoticeBar)
    .use(ImagePreview)
    .use(Swipe)
    .use(SwipeItem)
    .use(Lazyload);


Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$cookie = Cookie;
Vue.prototype.$wechatMark = 'yq'
Vue.prototype.$logisticsCompanyId = 'c2e46c8dfa804133a77205d27e6d72e3'
Vue.prototype.$logisticsCompanyName = '云企'
Vue.prototype.$logisticsCompanyId_hb = 'b491d97a087f4fe78dc5f9a48cedcb5d'
Vue.prototype.$logisticsCompanyName_hb = '河北云企驿站'

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
